function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { borderRadius, borderTop } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Box from '../Box';
import Text from '../Text';
import { SpreadsheetContext } from './SpreadsheetManager';
const StyledSpreadsheetFooter = styled(Text).withConfig({
  displayName: "SpreadsheetFooter__StyledSpreadsheetFooter",
  componentId: "sc-1usxke8-0"
})(["", " ", " border-top-left-radius:0;border-top-right-radius:0;border-top:", ";"], borderRadius, borderTop, props => themeGet('borders.bold')(props));
const SpreadsheetFooter = /*#__PURE__*/React.memo(_ref => {
  let {
    bg = 'gray.1',
    borderRadius = 'corner',
    borderTop = 'bold',
    fontSize = 1,
    px = 3,
    py = 2,
    ...props
  } = _ref;
  const {
    rows
  } = React.useContext(SpreadsheetContext);
  return /*#__PURE__*/React.createElement(StyledSpreadsheetFooter, _extends({
    bg: bg,
    borderRadius: borderRadius,
    borderTop: borderTop,
    fontSize: fontSize,
    px: px,
    py: py
  }, props), rows.length, " items");
});
SpreadsheetFooter.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...borderTop.propTypes,
  onAddFilter: PropTypes.func,
  onExportCsv: PropTypes.func,
  onManageColumns: PropTypes.func,
  onMaximizeSize: PropTypes.func,
  onRestoreSize: PropTypes.func
};
SpreadsheetFooter.displayName = 'SpreadsheetFooter';
export default SpreadsheetFooter;